import { Card, CardContent, Divider, Icon, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const CustomGenericCardComponent = ({ item, ...props }) => {

    const { content } = item;
    const { title, icon } = content || {};
    const { reducer } = useSelector((state) => state);
    const fontFamily = reducer?.pageJson?.pageStyle?.fontFamily || 'Roboto';

    return (
        <Card
            {...props}
            p={2}
            sx={{
                ...props.sx,
                width: "100%",
                borderRadius: "24px",
                textAlign: "center",
                borderColor: "#000000",
                height: '100%',
                ...item?.props?.style, // Apply styles from editor
                ...props.style
            }}
            onClick={() => {
                if (item?.url) {
                    if (typeof item?.url === "object") {
                        if (item?.url?.target) {
                            window.open(item?.url?.path, "_blank", "noopener,noreferrer");
                        } else {
                            // Handle internal navigation if needed, or rely on parentLink
                            window.location.href = item?.url?.path;
                        }
                    } else {
                        window.location.href = item?.url;
                    }
                }
            }}
        >
            <Stack spacing={1} alignItems={item?.props?.alignItems || 'center'} >

                {icon && (
                    <>
                        <Icon
                            className={`mdi mdi-${icon}`}
                            sx={{
                                color: item?.props?.style?.iconColor || 'inherit',
                                fontSize: item?.props?.style?.iconSize === 'small' ? 20 : item?.props?.style?.iconSize === 'medium' ? 30 : 40,
                            }}
                        />
                        <Divider sx={{ width: '100%', borderColor: item?.props?.style?.borderColor }} />
                    </>
                )}

                {title && (() => {
                    // Filter out non-text styles if they are mixed in style prop
                    const { backgroundColor, borderColor, borderWidth, borderStyle, iconColor, iconSize, ...titleStyle } = item?.props?.style || {};
                    return <Typography  sx={{ ...titleStyle,fontFamily: `${fontFamily}!important` }} >{title}</Typography>
                })()}
                {content?.content && <Typography sx={{ ...item?.props?.style2, px:3,py:1,fontFamily: `${fontFamily}!important`}} >{content?.content}</Typography>}

            </Stack>
        </Card>
    );
};

export default CustomGenericCardComponent;
